import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Pricing = lazy(() => import('./pricing'));

export function PricingPage() {
  return (
    <article className="space-y-6" data-testid="pricing-page">
      <Suspense fallback={<Loading />}>
        <Pricing />
      </Suspense>
    </article>
  );
}
